import { NativeDateAdapter } from "@angular/material";
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/core";
import * as i2 from "@angular/cdk/platform";
export class CustomDateAdapter extends NativeDateAdapter {
    getFirstDayOfWeek() {
        return 1;
    }
}
CustomDateAdapter.ngInjectableDef = i0.defineInjectable({ factory: function CustomDateAdapter_Factory() { return new CustomDateAdapter(i0.inject(i1.MAT_DATE_LOCALE, 8), i0.inject(i2.Platform)); }, token: CustomDateAdapter, providedIn: "root" });
